import { render, staticRenderFns } from "./404.vue?vue&type=template&id=245c3bc2&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=245c3bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c3bc2",
  null
  
)

export default component.exports